import React from "react";
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from "react-router-dom";

import { PATHS } from "../type/EnumPaths";
import { allBrands } from "../util/getDataAllBrands";

const BrandList = () => {
  return (
    <React.Fragment>
      {
        allBrands.map((data, index) => {
          return (
            <Typography
              key={`data-${index}`}
              component="p"
              variant="caption"
            >
              <Link
                color="inherit"
                to={`/${PATHS.BRANDS}/${data.id}`}
                component={RouterLink}
              >
                #{data.name}
              </Link>
            </Typography>
          )
        })
      }
    </React.Fragment>
  )
}

export default React.memo(BrandList);